const AnalysisType = Object.freeze({
  NONE: 'NONE',
  SW_AUTHOR: 'SW_AUTHOR',
  SW_EXPLORE: 'SW_EXPLORE',
  SW_CONVERSATION: 'SW_CONVERSATION',
  SW_CROSSTAB: 'SW_CROSSTAB',
  SW_DEMOGRAPHIC: 'SW_DEMOGRAPHIC',
  SW_DOMAIN: 'SW_DOMAIN',
  SW_GEOGRAPHY: 'SW_GEOGRAPHY',
  SW_LIKES_AND_DISLIKES: 'SW_LIKES_AND_DISLIKES',
  SW_SENTIMENT: 'SW_SENTIMENT',
  SW_SOURCE: 'SW_SOURCE',
  SW_STREAM: 'SW_STREAM',
  SW_SUMMARY: 'SW_SUMMARY',
  SW_TIMELINE_COMPARISON: 'SW_TIMELINE_COMPARISON',
  SW_TOP_LINKS: 'SW_TOP_LINKS',
  SW_TOP_TWEET: 'SW_TOP_TWEET',
  SW_TOPIC_COMPARISON: 'SW_TOPIC_COMPARISON',
  SW_ALL_IN_ONE: 'SW_ALL_IN_ONE',
  SW_BRAND_PASSION_INDEX: 'SW_BRAND_PASSION_INDEX',
  SW_BENCHMARK: 'SW_BENCHMARK',
  AM_AUTHOR: 'AM_AUTHOR',
  AM_CONVERSATION: 'AM_CONVERSATION',
  AM_CROSSTAB: 'AM_CROSSTAB',
  AM_DEMOGRAPHIC: 'AM_DEMOGRAPHIC',
  AM_GEOGRAPHY: 'AM_GEOGRAPHY',
  AM_LIKES_AND_DISLIKES: 'AM_LIKES_AND_DISLIKES',
  AM_SENTIMENT: 'AM_SENTIMENT',
  AM_STREAM: 'AM_STREAM',
  AM_SUMMARY: 'AM_SUMMARY',
  AM_TIMELINE_COMPARISON: 'AM_TIMELINE_COMPARISON',
  AM_TOP_LINKS: 'AM_TOP_LINKS',
  AM_TOPIC_COMPARISON: 'AM_TOPIC_COMPARISON',
  AM_ALL_IN_ONE: 'AM_ALL_IN_ONE',
  AM_THINGS: 'AM_THINGS',
  AM_BENCHMARK: 'AM_BENCHMARK',
  SW_OVERVIEW: 'SW_OVERVIEW',
  AM_TRENDING: 'AM_TRENDING',
  SW_TRENDING: 'SW_TRENDING',
  SW_MEDIA: 'SW_MEDIA',
  AM_MEDIA: 'AM_MEDIA',
  SW_NEW_SUMMARY: 'SW_NEW_SUMMARY',
  AM_NEW_SUMMARY: 'AM_NEW_SUMMARY',
  SW_POST_ACTIVITY: 'SW_POST_ACTIVITY',
  AM_POST_ACTIVITY: 'AM_POST_ACTIVITY',
  SW_GEO_TAGGED: 'SW_GEO_TAGGED',
  AM_GEO_TAGGED: 'AM_GEO_TAGGED',
  SW_LANGUAGE: 'SW_LANGUAGE',
  AM_LANGUAGE: 'AM_LANGUAGE',
  SW_TAGS: 'SW_TAGS',
  SW_CHANNEL_COMPARISON: 'SW_CHANNEL_COMPARISON',
  NP_CARD: 'NP_CARD',
  SW_SIDE_BY_SIDE: 'SW_SIDE_BY_SIDE',
  SW_PHOTO_CONCEPT: 'SW_PHOTO_CONCEPT',
  YT_SUMMARY: 'YT_SUMMARY',
  YT_STREAM: 'YT_STREAM'
})
export default AnalysisType
export type AnalysisTypeStrings = typeof AnalysisType[keyof typeof AnalysisType]
// RESERVE BELOW
